import { render, staticRenderFns } from "./overviewSection.vue?vue&type=template&id=3d5f12d2"
import script from "./overviewSection.vue?vue&type=script&lang=js"
export * from "./overviewSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports